import researchesDefault from '../data/field-researches.json';
import { FieldResearch, ResearchResponse } from '../types/fieldResearch';

const RESEARCHES_KEY = 'antares-researches';
const RESPONSES_KEY = 'antares-responses';

export function getResearches(): FieldResearch[] {
  const raw = localStorage.getItem(RESEARCHES_KEY);
  if (raw) return JSON.parse(raw) as FieldResearch[];
  return researchesDefault as FieldResearch[];
}

export function saveResearches(data: FieldResearch[]): void {
  localStorage.setItem(RESEARCHES_KEY, JSON.stringify(data));
}

export function getResponses(): ResearchResponse[] {
  const raw = localStorage.getItem(RESPONSES_KEY);
  if (!raw) return [];
  return JSON.parse(raw) as ResearchResponse[];
}

export function saveResponses(data: ResearchResponse[]): void {
  localStorage.setItem(RESPONSES_KEY, JSON.stringify(data));
}
